import { useNavigate } from "react-router";
import StammbaumImage from "../../assets/images/stammbaum.png?no-inline";
import Intro, { IntroColor } from "../../components/blocks/Intro/Intro";
import Button from "../../components/core/Button/Button";
import Image from "../../components/core/Image/Image";
import { translate } from "../../localization";
import { routes } from "../router/utils";
import Map from "./Map";
import Objects from "./Objects";
import Slider from "./Slider";

const Home = () => {
  const i18n = translate();
  const navigate = useNavigate();

  return (
    <>
      <Slider />
      <Intro headline={i18n.home.intro.headline} text={i18n.home.intro.text} />
      <Intro
        headline={i18n.home.persons.headline}
        text={i18n.home.persons.text}
        color={IntroColor.Beige2}
        image={<Image src={StammbaumImage} />}
        button={
          <Button
            buttonProps={{
              title: i18n.home.persons.button,
              onClick: () => {
                navigate(routes.browse.index);
              },
            }}
          >
            {i18n.home.persons.button}
          </Button>
        }
      />
      <Intro
        headline={i18n.home.intro2.headline}
        text={i18n.home.intro2.text}
      />
      <Intro
        headline={i18n.home.objects.headline}
        text={i18n.home.objects.text}
        color={IntroColor.Beige2}
      >
        <Objects />
      </Intro>
      <Intro
        headline={i18n.home.intro3.headline}
        text={i18n.home.intro3.text}
      />
      <Map />
    </>
  );
};

export default Home;
